var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "#45525B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7013 26.5813C16.0519 26.4236 16.4416 26.5813 16.5974 26.936C16.7532 27.2906 16.5974 27.6847 16.2468 27.8424C14.4545 28.6305 13.4026 29.6158 13.4026 30.5616C13.4026 32.4926 17.7273 34.6601 24 34.6601C30.2727 34.6601 34.6364 32.4926 34.5974 30.5616C34.5974 29.6158 33.5844 28.6305 31.8312 27.8818C31.4805 27.7241 31.3247 27.33 31.4805 26.9754C31.6364 26.6207 32.026 26.4631 32.3766 26.6207C34.7143 27.6453 36 29.0246 36 30.5616C36 33.6355 30.8571 36 24 36C17.1429 36 12 33.6749 12 30.5616C12 29.0246 13.3247 27.6059 15.7013 26.5813ZM24 12C28.3247 12 31.8312 15.5468 31.8312 19.9212C31.8312 23.1921 27.7403 28.3153 25.2857 31.0739C24.974 31.468 24.5065 31.665 24 31.665C23.4935 31.665 23.026 31.4286 22.7143 31.0739C20.2597 28.3153 16.1688 23.1921 16.1688 19.9212C16.1688 15.5468 19.6753 12 24 12ZM24 13.3793C20.4545 13.3793 17.5325 16.2956 17.5325 19.9212C17.5325 21.931 19.8701 25.7537 23.7273 30.1281C23.8052 30.2463 23.961 30.2463 24 30.2463C24.039 30.2463 24.1558 30.2463 24.2727 30.1281C28.1688 25.7537 30.4675 21.931 30.4675 19.9212C30.4675 16.2956 27.5455 13.3793 24 13.3793Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.ba06c8b893dfa65f7caf04daa7a547ae.svg";
export { ForwardRef as ReactComponent };